export default "__VITE_ASSET__D$72_CMl__"